import { type FeatureFlag } from './featureFlags';

export const VariableTypes = {
  BOOLEAN: 'boolean',
  DOUBLE: 'double',
  INTEGER: 'integer',
  STRING: 'string',
} as const;

export type VariableTypeName = (typeof VariableTypes)[keyof typeof VariableTypes];

type VariableTypeMap = {
  boolean: boolean;
  double: number;
  integer: number;
  string: string;
};

type TypedVariables<T extends Record<string, VariableTypeName>> = {
  [K in keyof T]: VariableTypeMap[T[K]];
};

export type VariablesForFlag<F extends FeatureFlag> = F extends {
  variables: infer V extends Record<string, VariableTypeName>;
}
  ? TypedVariables<V>
  : never;
